import { jsonMember, jsonObject } from 'typedjson';
import { CollectionFilterOperator } from '../enums/collection-filter-operator';
import { CollectionFilterValue } from '../../collection/types/collection-filter-value';
import { collectionFilterValueSerializer } from '../../json/serializers/collection-filter-value.serializer';
import { noopDeserializer } from '../../json/deserializers/noop.deserializer';

@jsonObject
export class CollectionFilterRequest {
  @jsonMember(String)
  public readonly property!: string;

  @jsonMember({
    deserializer: noopDeserializer(),
    serializer: collectionFilterValueSerializer(),
  })
  public readonly value!: CollectionFilterValue;

  @jsonMember(String)
  public readonly operator!: CollectionFilterOperator;

  public constructor(
    property: string,
    value: CollectionFilterValue,
    operator: CollectionFilterOperator,
  ) {
    this.property = property;
    this.value = value;
    this.operator = operator;
  }
}
